/**
 * Centralized route definitions.
 * Single source of truth for all application routes.
 * Use these constants instead of hardcoding paths.
 */

export const ROUTES = {
	// ─── Public ─────────────────────────────────
	HOME: '/',
	PRICES: '/prices',

	// ─── Auth ───────────────────────────────────
	LOGIN: '/login',
	REGISTER: '/register',
	FORGOT_PASSWORD: '/forgot-password',
	RESET_PASSWORD: '/reset-password',

	// ─── Private ────────────────────────────────
	DASHBOARD: '/dashboard',

	ONBOARDING: '/onboarding',
	PROFILE: '/profile',
	CHANGE_PASSWORD: '/profile/change-password',
	CHAT: '/chat',
	QUESTIONS: '/questions',
	ANALYSIS: '/analysis',
	PROGRESS: '/progress',
	ANNOUNCEMENTS: '/announcements',
	NOTIFICATIONS: '/notifications',
	ABOUT: '/about',
	CHECKOUT: '/checkout',
	PUSH_TEST: '/push-test',
	SPLASH: '/splash',
} as const

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES]

/**
 * Routes that don't require authentication.
 */
export const PUBLIC_ROUTES: readonly string[] = [
	ROUTES.HOME,
	ROUTES.PRICES,
	ROUTES.LOGIN,
	ROUTES.REGISTER,
	ROUTES.FORGOT_PASSWORD,
	ROUTES.RESET_PASSWORD,
]

/**
 * Routes that should redirect to dashboard if user is already authenticated.
 */
export const AUTH_ROUTES: readonly string[] = [
	ROUTES.LOGIN,
	ROUTES.REGISTER,
	ROUTES.FORGOT_PASSWORD,
	ROUTES.RESET_PASSWORD,
]

/**
 * Default redirect after login.
 */
export const DEFAULT_LOGIN_REDIRECT = ROUTES.DASHBOARD

/**
 * Default redirect for unauthenticated users.
 */
export const DEFAULT_UNAUTHENTICATED_REDIRECT = ROUTES.LOGIN
